
export default {
  name: "VideoButton",
  props: ['link']
}
